import React, { useEffect, useState } from 'react'
import { Titles } from '../../constant/PageTitle'
import { Card, Input, Pagination, Space, Spin, } from 'antd'
import '../../style/page.css'
import { SearchIcon, } from 'lucide-react';
import DefaultImage from '../../assets/png/defaultImgIcon.jpg'
import { useDispatch, useSelector } from 'react-redux';

import { getModules, setPagination, setSearchParams } from '../../feature/modules/moduleSlice';
import EditModule from './EditModule';


function ModuleList() {
    const [value, setValue] = useState("")
    const dispatch = useDispatch()
    const { modulesList, isLoading, totalPage, limit, current, searchParams } = useSelector((state) => state.modules);

    const handlePagination = (page) => {
        dispatch(setPagination(page))
    };

    console.log("modulesList", modulesList)

    const fetchModulesList = async () => {
        dispatch(getModules({ current, limit, searchParams })); // send params if needed
    }
    useEffect(() => {
        fetchModulesList()
    }, [current, searchParams])


    useEffect(() => {
        const timer = setTimeout(() => {
            dispatch(setSearchParams(value));
        }, 1000);

        return () => clearTimeout(timer);
    }, [value]);

    function handleSearch(e) {
        setValue(e.target.value);
    }
    return (
        <section>
            <Card>
                <div className="page_title">
                    <p>{Titles.module}</p>
                    <Space>
                        <Input allowClear size='large' suffix={<SearchIcon color='lightGray' size={16} />} placeholder="Search" onChange={handleSearch} variant="filled" />
                        {/* <AddModule /> */}
                    </Space>
                </div>
            </Card>
            <div className="page_content">
                {isLoading ? <Spin  fullscreen /> :
                    <div className="show_modules">
                        {modulesList.map((item) => (
                            <>
                                <Card  hoverable actions={[<h3>{item.quickAccessName}</h3>, <EditModule editData={item} />]}>
                                    <img src={item.quickAccessIcon || DefaultImage} onError={(e) => (e.target.src = DefaultImage)} />
                                </Card>
                            </>
                        ))}
                    </div>
                }
            </div>
            <div className="pagination">
                <Pagination
                    current={current}
                    onChange={handlePagination}
                    total={totalPage ? totalPage * 10 : 0}
                />
            </div>
        </section >
    )
}


export default ModuleList